module.exports = __webpack_public_path__ + "assets/768fd1a5ae7284f4db309833795eba0c.png";